const reportNames = {
    INVOICE_REPORT: 'ReInvoiceReport',
    COMMISSION_REPORT: 'ReCommissionsReport',
    SINGLE_INVOICE_REPORT: 'ReSingleInvoiceReport',
    SINGLE_ORDER_REPORT: 'ReSingleOrderReport',
    RE_PENDING_RETRUN: 'RePendingReturn',
};

export default reportNames;
